/**
 * Featured Post Slider — slide counter.
 *
 * Listens for UIkit slider `itemshow` events and updates the "01 / 04" counter
 * displayed in the section header. Each slider instance is wired independently
 * via a data attribute so multiple sliders on the same page work correctly.
 */

import UIkit from 'uikit';

function initFeaturedPostSliders() {
    document.querySelectorAll('.fps__slider[uk-slider]').forEach(function (slider) {
        const counterId    = slider.getAttribute('data-fps-counter');
        const currentEl    = counterId ? document.querySelector('#' + counterId + ' .fps__counter-current') : null;
        const progressBtns = slider.querySelectorAll('.fps__progress-btn');

        UIkit.util.on(slider, 'itemshow', function (e) {
            const item  = e.detail[0];
            const index = item ? item.index : 0;

            if (currentEl) {
                currentEl.textContent = String(index + 1).padStart(2, '0');
            }

            progressBtns.forEach(function (btn, i) {
                const active = i === index;
                btn.classList.toggle('fps__progress-btn--active', active);
                btn.setAttribute('aria-current', active ? 'true' : 'false');
            });
        });
    });
}

export default initFeaturedPostSliders;
